import { IconProps } from '../../types/IconProps';

export const FiltersActive = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='28'
    height='28'
    fill='none'
    className={`${className || ''}`}>
    <path
      fill={variant === 'light' ? '#fff' : '#0B223E'}
      d='M17.985 15.9a.665.665 0 0 1-.665.666H6.68a.665.665 0 1 1 0-1.33h10.64c.368 0 .665.297.665.665Zm2.66-4.654H3.355a.665.665 0 0 0 0 1.33h17.29a.665.665 0 1 0 0-1.33Zm-6.65 7.98h-3.99a.665.665 0 0 0 0 1.33h3.99a.665.665 0 1 0 0-1.33Z'
    />
    <circle cx='24' cy='4' r='4' fill='#E65CC1' />
  </svg>
);
